<template>
  <div id="beer" :class="`ani${ani} ${isWidth}`">
      <!-- 页面标题 -->
      <div v-wechat-title="'888元现金福利！玩游戏领现金'"></div>

      <!-- 转盘页 -->
      <div class="content-01">
        <div class="btn-wrap">
          <div class="btn award" @click="ani === 10 ? showPopup('award') : ''"></div>
          <div class="btn rule" @click="ani === 10 ? showPopup('rule') : ''"></div>
        </div>
        <div class="turntable-wrap">
          <div :class="`turntable ani${award_id} ${ani > 3}`"></div>
          <div :class="'lottery-btn ' + (cursorHandle && (ani === 1 || ani === 5 || ani === 8 || !award_id))" @click="lottery()"></div>
          <div class="num">抽奖次数：<span>{{ times }}</span></div>
        </div>
        <div class="next-icon"></div>
      </div>

      <!-- 任务页 -->
      <div class="content-02">
        <div class="task">
          <div :class="`btn btn${item.status}`" v-for="(item,index) in task_list" :key="index" @click="onTask({id: item.id, status: item.status})"></div>
        </div>
      </div>

      <!-- 弹窗 -->
      <div class="popupWrap">
        <!-- 我的奖品 -->
        <div :class="`popup award ${popup.award}`">
          <div class="popup-main">
            <div class="bind">{{ `当前绑定的角色：${user_info.role_name}` }}</div>
            <div class="nav">
              <div :class="`money ${isMoney}`" @click="isMoney = true">红包</div>
              <div :class="`prop ${!isMoney}`" @click="onProp()">道具</div>
            </div>
            <div class="top" @click="onReward()">
              <div class="left">名称</div>
              <div class="center">时间</div>
              <div class="right">状态</div>
            </div>
            <div class="wrap">
              <div class="inner">
                <!-- 红包 -->
                <div class="item" v-show="isMoney" v-for="(item,index) in money_list" :key="`money${index}`">
                  <div class="left">{{ item.package_name }}</div>
                  <div class="center">{{ item.created_at }}</div>
                  <div class="right">
                    <span>已发放</span>
                  </div>
                </div>
                <!-- 道具 -->
                <div class="item" v-show="!isMoney" v-for="(item,index) in prop_list" :key="`prop${index}`">
                  <div class="left">{{ item.package_name }}</div>
                  <div class="center">{{ item.created_at }}</div>
                  <div class="right">
                    <div :class="`receive-btn btn${item.is_get}`" @click="item.is_get ? '' : receive({id: item.id, index: index})"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="notice" v-show="isMoney">现金红包已通过“青瓷游戏Wiki”小程序发放</div>
            <div class="close-btn" @click="popup.award = false, isMoney = true"></div>
          </div>
        </div>

        <!-- 绑定角色 -->
        <div :class="`popup bind ${popup.bind}`">
          <div class="popup-main">
            <!-- 选择的区组 -->
            <div class="server" @click="isList = !isList">{{ server_select.server_name ? `${server_select.server_name} ${server_select.server_id}服` : '请选择区组' }}</div>
            <!-- 选择的角色 -->
            <div class="role">{{ server_select.role_name ? server_select.role_name : '请选择角色' }}</div>
            <!-- 区服信息 -->
            <div class="server_list" v-show="isList">
              <div :class="`item ${server_select.role_id === undefined}`" @click="server_select = {}, isList = false">请选择区组</div>
              <div :class="`item ${server_select.role_id === item.role_id}`" v-for="(item,index) in server_info" :key="index" @click="server_select = item, isList = false">{{ `${item.server_name} ${item.server_id}服` }}</div>
            </div>
            <div class="confirm-btn" @click="onBind()">确定</div>
          </div>
        </div>

        <!-- 领奖提示 -->
        <div :class="`popup tip ${popup.tip}`">
          <div class="popup-main">
            <div class="close-btn" @click="popup.tip = false"></div>
          </div>
        </div>

        <!-- 活动规则 -->
        <div :class="`popup rule ${popup.rule}`">
          <div class="popup-main">
            <div class="close-btn" @click="popup.rule = false"></div>
          </div>
        </div>

        <!-- 抽奖次数不足 -->
        <div :class="`popup none ${popup.none}`">
          <div class="popup-main"></div>
        </div>

        <!-- 任务全部完成 -->
        <div :class="`popup finish ${popup.finish}`">
          <div class="popup-main"></div>
        </div>

        <!-- 抽奖结果 -->
        <div :class="`popup result ${popup.result}`" @click="popup.result = false, award_id = null">
          <div :class="`popup-main award${award_id}`">
            <div class="text"></div>
            <div class="light"></div>
            <div class="prize"></div>
          </div>
        </div>

        <!-- 防抖遮罩 -->
        <div :class="`popup mask ${popup.mask}`"></div>

      </div>

      <!-- 非微信扫码页 -->
      <div class="others">
        <div class="others-main"></div>
        <div class="bottom"></div>
      </div>

      <!-- 动画层 -->
      <div class="ani-wrap">
        <div class="item-01"></div>
        <div class="item-02"></div>
        <div class="item-03"></div>
        <div class="item-04"></div>
        <div class="item-05" @click="ani === 7 ? onLink('最强蜗牛_啤酒广告CPS抽奖活动_二次抽奖后点击继续抽跳转至小游戏') : ''"></div>
        <div class="item-06"></div>
        <div class="item-07"></div>
        <div class="item-08" @click="ani === 9 ? onLink('最强蜗牛_啤酒广告CPS抽奖活动_三次抽奖后点击继续抽跳转至小游戏') : ''"></div>
        <div class="item-09" @click="ani === 4 ? onLink('最强蜗牛_啤酒广告CPS抽奖活动_首次抽奖后点击继续抽跳转至小游戏') : ''"></div>
        <div class="item-10" @click="ani === 9 ? (ani = 10, showPopup('bind')) : ''"></div>
        <div class="item-11" @click="ani === 9 ? (ani = 10, showPopup('bind')) : ''"></div>
      </div>
  </div>
</template>

<script>
import { onInitAPI, onListAPI, onLinkAPI, onDrawAPI, onRewardAPI, onTaskAPI, onServerAPI, onBindAPI } from '../api'
import { Toast } from 'mint-ui'
import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'beer',
  data () {
    return {
      isWidth: null, // 宽屏
      type: null, // 1啤酒广告，2游戏圈活动
      ani: null, // 动画帧
      game_link: null, // 游戏链接
      cursorHandle: true, // false手动隐藏小手
      isMoney: true, // 奖品展示为红包
      isList: '', // 显示区服选项
      server_select: {}, // 选择的区服选项
      role_name: '',
      popup: {
        award: false, // 我的奖品
        bind: false, // 绑定角色
        tip: false, // 领奖提示
        rule: false, // 活动规则
        none: false, // 抽奖次数不足
        finish: false, // 任务全部完成
        result: false, // 抽奖结果
        mask: true, // 防抖遮罩
      },

      money_list: [], // 红包奖品列表
      money_page: 1,
      money_total: null,
      prop_list: [], // 道具奖品列表
      prop_page: 1,
      prop_total: null,
      times: null, // 剩余抽奖次数
      award_id: null, // 抽取的奖品id
      consume: '', // 已抽取次数
      task_list: ['', '', '', '', ''], // 任务列表
      finish: false, // 当天任务全部已领取
      user_info: {}, // 角色信息
      server_info: [] // 区服信息

      // ani动画：
      // ani1：未进行抽奖
      // ani2：进行第1次抽奖（获得特权=>去掉谢谢参与页），自动连播ani3
      // ani3：去掉谢谢参与动画，自动连播ani4
      // ani4：已抽奖1次，无抽奖机会（抽奖次数不足页=>继续抽页）- 中途退出抽奖 或 从游戏返回
      // ani5：已抽奖1次，有抽奖机会（正常仅首屏）
      // ani6：进行第2次抽奖（转盘动画=>游戏礼包页），自动连播ani7
      // ani7：已抽奖2次，无抽奖机会（100%现金动画）- 中途退出抽奖 或 从游戏返回
      // ani8：已抽奖2次，有抽奖机会（正常仅首屏）
      // ani9：进行第3次抽奖（转盘动画=>继续抽现金页）
      // ani10：完成3次抽奖正常页

      // award_id奖品id:
      // 1：888现金
      // 2：88现金
      // 3：0.88现金
      // 4：0.01现金
      // 5：68道具
      // 6：30道具
      // 7：12道具
      // 8：6道具
      // 9：1道具
      // 10： 谢谢参与
    }
  },
  created () {
    // 复写
    if (!global.consoleSwitch) console.log = () => {}

    // 自适应
    window.addEventListener('pageshow', this.resize)
    window.addEventListener('resize', this.resize)

    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()

    // 埋点
    const bl = buriedLogger('snail', '最强蜗牛_啤酒广告CPS抽奖活动')
    this.logger = bl
    setTimeout(() => {
      this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_访问页面')
    }, 200)

    this.isSetShare()
  },
  mounted () {
    if(this.isWechatBrowser()) {
      // 微信环境下
      document.querySelector('.others').className = ''
      this.onInit()
      this.onReward()
    }
  },
  methods: {
    // 自适应
    resize () {
      const beer = document.querySelector('#beer')
      const ratio = window.innerHeight / window.innerWidth
      if (this.timer1) clearTimeout(this.timer1)
      if (window.innerWidth >= 540) document.documentElement.style.fontSize = '54px'
      if (ratio < 600 / 320 ) {
        if (beer.className.indexOf('width') === -1) this.isWidth = 'width'
      } else {
        this.isWidth = ''
      }
      setTimeout(() => { document.querySelector('#beer').style.opacity = 1 }, 300)
    },
    // 初始化
    onInit () {
      const params = analysisParams(window.location.href)
      const source = params.type
      this.game_link = source === 1 ? 'https://ad.qingcigame.com/v1/ad-click?game_id=70&os=Android&company=qc&channel=wechatkol&tag=1153171&optimizer_id=19&env_version=release' : 'https://ad.qingcigame.com/v1/ad-click?game_id=70&os=Android&company=qc&channel=wechatkol&tag=1153172&optimizer_id=19&env_version=release'
      onInitAPI({
        source
      }).then(response => {
        if (Number(response.code) === 200) {
          this.consume = response.data.activity.consume
          this.task_list = response.data.activity.task_list
          this.times = response.data.activity.times
          this.user_info = response.data.user_info

          this.finish = this.task_list.every(item => item.status === 2)

          let that = this
          setTimeout(() => {
            // 判断ani值
            switch (that.consume) {
              case 0:
                that.ani = 1
                setTimeout(() => { that.popup.mask = false }, 1800) // 可操作
                break
              case 1:
                that.ani = that.times ? 5 : 4
                if (that.ani === 5) that.popup.mask = false
                break
              case 2:
                that.ani = that.times ? 8 : 7
                if (that.ani === 8) that.popup.mask = false
                break
              default:
                that.ani = 10
                that.popup.mask = false
                if (!that.user_info.role_id) {
                  that.popup.bind = true
                  that.onServer()
                }
                break
            }
          }, 300)
          return
        }
        //未授权
        if (Number(response.code) == 302) {
          var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            // 如果在微信里面
            window.location.href =
              response.data["wechat_url"] +
              "?callback=" +
              encodeURI(window.location.href);
            return;
          } else {
            // 如果在QQ里面
            window.location.href =
              response.data["qq_url"] +
              "?callback=" +
              encodeURI(window.location.href);
            return;
          }
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      })
    },
    // 打开弹窗
    showPopup (name) {
      let that = this
      switch (name) {
        case 'award':
          if (!this.money_list.length) this.onList()
          this.popup.award = true
          this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_打开我的奖品弹窗')
          break
        case 'bind':
          this.popup.bind = true
          this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_打开绑定角色弹窗')
          break
        case 'tip':
          this.popup.tip = true
          this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_点击领取道具奖励')
          break
        case 'rule':
          this.popup.rule = true
          this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_打开活动规则弹窗')
          break
        case 'none':
          this.popup.none = true
          setTimeout(() => {
            that.popup.none = false
            this.popup.mask = false
          }, 1500)
          break
        case 'finish':
          this.popup.finish = true
          setTimeout(() => {
            that.popup.finish = false
            this.popup.mask = false
          }, 1500)
          break
        case 'result':
          this.popup.mask = true
          this.popup.result = true
          setTimeout(() => { that.popup.mask = false }, 800)
          break
      }
    },
    // 抽奖
    lottery () {
      this.popup.mask = true // 防抖
      let that = this
      switch (this.consume) {
        case 0:
          // 第一次抽奖
          document.querySelector('.turntable-wrap').className += ' over' // 移除黑幕
          this.award_id = 10 // 抽中谢谢参与动画
          this.cursorHandle = false // 隐藏小手
          setTimeout(() => {
            that.ani = 2
            that.resize()
            setTimeout(() => {
              that.ani = 3
              that.resize()
              this.award_id = null
              setTimeout(() => { that.ani = 3.5 }, 1200) // 替换转盘
              setTimeout(() => {
                that.ani = 4
                that.resize()
                setTimeout(() => { that.popup.mask = false }, 2500)
              }, 2000)
            }, 3800)
          }, 5000)
          break
        case 1:
          this.award_id = 9 // 抽中1元游戏礼包
          this.cursorHandle = false // 隐藏小手
          setTimeout(() => {
            that.ani = 6
            that.resize()
            setTimeout(() => {
              that.ani = 7
              that.resize()
              setTimeout(() => { that.popup.mask = false }, 1800)
            }, 2000)
          }, 5000)
          break
        case 2:
          this.award_id = 4 // 抽中0.01元现金红包
          this.cursorHandle = false // 隐藏小手
          setTimeout(() => {
            that.ani = 9
            that.resize()
            setTimeout(() => { that.popup.mask = false }, 3800)
          }, 5000)
          break
        default:
          if (!this.times) return this.finish ? this.showPopup('finish') : this.showPopup('none')
          break
      }
      onDrawAPI().then(response => {
        if (Number(response.code) === 200) {
          if (this.consume > 2) {
            this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_点击抽奖')
            this.times--
            this.award_id = response.data.id
            setTimeout(() => {
              that.showPopup('result')
              this.money_list = []
              this.prop_list = []
              this.money_page = 1,
              this.money_total = null,
              this.prop_page = 1,
              this.prop_total = null
            }, 5000)
          }
          return
        }
        this.onToast(response.message)
      })
    },
    // 获取奖品列表
    onReward() {
      const wrap = document.querySelector('.popup.award .wrap')
      const inner = document.querySelector('.popup.award .wrap .inner')
      const that = this
      wrap.addEventListener('scroll', function() {
        if (wrap.offsetHeight + wrap.scrollTop >= inner.offsetHeight) that.onList()
      })
    },
    // 领取道具奖励
    receive ({id, index}) {
      onRewardAPI({
        id
      }).then(response => {
        if (Number(response.code) === 200) {
          this.prop_list[index].is_get = 1
          this.showPopup('tip')
          return
        }
        this.onToast(response.message)
      })
    },
    // 角色查询
    onServer () {
      onServerAPI({
        app_id: 70
      }).then(response => {
        if (Number(response.code) === 200) {
          this.server_info = response.data.small
          return
        }
        this.onToast(response.message)
      })
    },
    // 绑定角色
    onBind () {
      if (!this.server_select.role_id) return this.onToast('请选择角色')
      onBindAPI({
        role_id: this.server_select.role_id,
        role_name: this.server_select.role_name,
        server_id: this.server_select.server_id,
        server_name: this.server_select.server_name,
        extra: this.server_select.extra,
        game_id: 70,
        token: this.server_select.extra.token
      }).then(response => {
        if (Number(response.code) === 200) {
          this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_绑定成功')
          this.popup.bind = false
          this.onInit()
          return
        }
        this.onToast(response.message)
      })
    },
    // 任务按钮
    onTask ({id, status}) {
      if (status === 1) {
        // 未领取
        onTaskAPI({
          task_id: id
        }).then(response => {
          if (Number(response.code) === 200) {
            this.logger.sum('最强蜗牛_啤酒广告CPS抽奖活动_领取任务奖励')
            this.onInit()
            return
          }
          this.onToast(response.message)
        })
      } else {
        // 不可领取
        this.goLink(this.game_link, '最强蜗牛_啤酒广告CPS抽奖活动_点击任务按钮跳转至小游戏')
      }
    },
    // 拓充奖品列表
    onList() {
      const type = this.isMoney ? 5 : 4
      if (type === 5) {
        if (this.money_total && this.money_page > this.money_total) return
      } else {
        if (this.prop_total && this.prop_page > this.prop_total) return
      }
      onListAPI({
        type,
        page: type === 5 ? this.money_page : this.prop_page
      }).then(response => {
        if (Number(response.code) === 200) {
          const list = response.data.data
          list.forEach(item => {
            item.created_at= this.onText(item.created_at)
          })
          if (type === 5) {
            // 红包列表
            this.money_list = this.money_list.concat(list)
            this.money_total = response.data.total
            this.money_page++
            if (this.money_total === 2 && this.money_page === 2) this.onList(type) // 每页10条，首次展示11条即两页
          } else {
            // 道具列表
            this.prop_list = this.prop_list.concat(list)
            this.prop_total = response.data.total
            this.prop_page++
            if (this.prop_total === 2 && this.prop_page === 2) this.onList(type) // 每页10条，首次展示11条即两页
          }
          return
        }
        this.onToast(response.message)
      })
    },
    // 前三次抽奖跳转游戏
    onLink (text) {
      onLinkAPI().then(response => {
        if (Number(response.code) === 200) {
          this.goLink(this.game_link, text)
          return
        }
        this.onToast(response.message)
      })
    },
    // 我的奖品弹窗-道具按钮
    onProp() {
      this.isMoney = false
      if (!this.prop_list.length) this.onList()
    },
    // 时间转文本
    onText(time) {
      const arr = time.split(' ')[0].split('-')
      return `${arr[1]}.${arr[2]}`
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    // 前往重定向
    goLink (url, loggerName) {
      if (url === '') return this.onToast('敬请期待！')
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url }, 200)
    },
    // 是否是微信浏览器
    isWechatBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.match(/Micromessenger/i) && ua.match(/Micromessenger/i)[0] === 'micromessenger'
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/beer/enter${getTimeStamp()}`,
        title: '888元现金福利！玩游戏领现金',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/3VCSAyyP794oQWWj2GGgc1zo40sA9SjRJRabr4Ho.png',
        desc: '888元现金限时发放，玩的多抽的多'
      })
    },
    ...mapMutations(['setInitUserInfo', 'changeOsPopup', 'setInitActiveInfo', 'changeLoginPopup']),
    ...mapActions(['setShare', 'onInitDataCallback'])
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs'])
  }
}
</script>

<style lang="less">
@import './index.less';
</style>


// WEBPACK FOOTER //
// src/pages/snail/beer/index/index.vue